// ── 3 Anmeldung ── das Formular. Je Verfahren ein Block, versteckt solange es
// nicht gewählt ist; die Redirect-URI steht zum Kopieren da, „Speichern und
// prüfen" fragt Discovery und Token-Endpoint mit dem, was gespeichert ist.

import { post } from "../../api/client";
import type { ProbeResult } from "../../api/types";
import { AUTH_MODE } from "../../lib/labels";
import { CopyField } from "../../ui/copy-field";
import { Check, Field, Input } from "../../ui/field";
import type { AuthState } from "./auth";
import { Probe } from "./probe";
import { fieldError, secretPlaceholder, setter, Warnings } from "./shared";
import type { StepFormProps } from "./types";

type TextKey = Exclude<keyof AuthState, "modes">;

export function AuthForm({ tenant: t, catalog: cat, state, setState, check, save }: StepFormProps<AuthState>) {
  const set = setter(setState);
  const on = (m: string) => state.modes.includes(m);
  const toggle = (m: string, checked: boolean) => setState((s) => ({ ...s, modes: checked ? [...s.modes.filter((x) => x !== m), m] : s.modes.filter((x) => x !== m) }));
  const input = (k: TextKey, label: string, extra: { type?: string; placeholder?: string } = {}) => {
    const err = fieldError(check, k);
    const secret = extra.type === "password";
    return (
      <Field label={label} error={err}>
        <Input
          name={k} type={extra.type ?? "text"} value={state[k]} placeholder={extra.placeholder} invalid={!!err}
          autoComplete={secret ? "new-password" : undefined} onChange={(e) => set(k)(e.target.value)}
        />
      </Field>
    );
  };
  // „Erst speichern, dann prüfen" — die Probe liest den gespeicherten Stand.
  // Wie früher auch dann, wenn das Speichern scheitert (die Meldung steht da).
  const probe = (mode: string) => async () => {
    await save();
    return post<ProbeResult>(`/tenants/${t.id}/checks/auth`, { mode });
  };
  return (
    <>
      <div className="pf-list">
        {cat.auth_modes.map((m) => {
          const [label, hint] = AUTH_MODE[m] ?? [m, ""];
          return <Check key={m} name="modes" value={m} checked={on(m)} onChange={(c) => toggle(m, c)} label={label} hint={hint} />;
        })}
      </div>
      <div className="pf-integration" hidden={!on("entra")}>
        <div className="pf-integration__head"><strong>Microsoft Entra</strong></div>
        <div className="pf-integration__fields pf-list">
          <Field label="Redirect-URI (in der App-Registrierung eintragen)" wide><CopyField value={t.redirect_uris.entra} /></Field>
          <div className="pf-grid">
            {input("entra_tenant_id", "Tenant-ID")}
            {input("entra_client_id", "Client-ID")}
            {input("entra_secret", "Client-Secret", { type: "password", placeholder: secretPlaceholder(t.auth_secrets_set?.entra) })}
          </div>
          <Probe label="Speichern und prüfen" outId="probe-entra" run={probe("entra")} />
        </div>
      </div>
      <div className="pf-integration" hidden={!on("oidc")}>
        <div className="pf-integration__head"><strong>OIDC</strong></div>
        <div className="pf-integration__fields pf-list">
          <Field label="Redirect-URI (beim Anbieter eintragen)" wide><CopyField value={t.redirect_uris.oidc} /></Field>
          <div className="pf-grid">
            {input("issuer", "Issuer", { placeholder: "https://…" })}
            {input("client_id", "Client-ID")}
            {input("oidc_secret", "Client-Secret", { type: "password", placeholder: secretPlaceholder(t.auth_secrets_set?.oidc) })}
            {input("scopes", "Scopes", { placeholder: "openid profile email" })}
            {input("display_name", "Beschriftung des Knopfs", { placeholder: "Mit Firmenkonto anmelden" })}
          </div>
          <Probe label="Speichern und prüfen" outId="probe-oidc" run={probe("oidc")} />
        </div>
      </div>
      <Warnings check={check} />
    </>
  );
}
